import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { IAppConfig } from '../models/config';
import { AuthConfig, OAuthErrorEvent, OAuthService } from 'angular-oauth2-oidc';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    static settings: IAppConfig;

    constructor(private http: HttpClient, private oAuthService: OAuthService) {}

    public static getBaseApiUrl(): string {
        return ConfigService.settings.apiBaseUrl;
    }

    async load(): Promise<void> {
        try {
            ConfigService.settings = environment as IAppConfig;

            const authConfig = new AuthConfig(ConfigService.settings.auth);
            this.oAuthService.configure(authConfig);
            this.oAuthService.setupAutomaticSilentRefresh();

            try {
                await this.oAuthService.loadDiscoveryDocumentAndTryLogin();
            } catch (e) {
                if (!(e instanceof OAuthErrorEvent)) {
                    // try login here may have exception which we don't need to handle.
                    throw e;
                }
            }
        } catch (e) {
            throw Error(`Could not load the environment variables`);
        }
    }

    public getSettings(): IAppConfig {
        return ConfigService.settings;
    }
}
